import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/fee/subject/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/fee/subject/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/fee/subject/del', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/fee/subject/save', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/fee/subject/submit', params,options)

export const statusChange = (params, options) =>
  request.post('/api/v4ward/fee/subject/statusChange',params,options);
